import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {

  getRoles(config) {
    return axiosInstance.get('/master/roles', {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  create(data) {
    return axiosInstance.post('/master/roles', data, {
      cancelToken: getNewCancelToken(),
    });
  },
  delete(id, config) {
    return axiosInstance.delete(`/master/roles/${id}`, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  update(id, data, config) {
    return axiosInstance.put(`/master/roles/${id}`, data, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  getRolePermissions(config) {
    return axiosInstance.get('/master/role_permission', {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  addRolePermission(data, config) {
    return axiosInstance.post('/master/role_permission', data, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  updateRolePermission(id, data, config) {
    return axiosInstance.put(`/master/role_permission/${id}`, data, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  deleteRolePermission(id, config) {
    return axiosInstance.delete(`/master/role_permission/${id}`, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  getUserRoles(config) {
    return axiosInstance.get('/master/user_role', {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  addUserRole(data, config) {
    return axiosInstance.post('/master/user_role', data, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },

};
